(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-charity-payout/assets/react/components/charity-payout.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-charity-payout/assets/react/components/charity-payout.js');

'use strict';

const {
  useEffect,
  useState
} = React;
const {
  useAtomValue
} = jotai;
const {
  CharityPayoutChart
} = svs.lyckoplatsen.components.shared_charity_payout.react.components;
const {
  charityPayoutChartAtom
} = svs.lyckoplatsen.shared_charity_payout.jotai.atoms;
const {
  useCharityPayout
} = svs.lyckoplatsen.components.shared_charity_payout.react.hooks;
const CharityPayout = () => {
  const [isHorizontal, setIsHorizontal] = useState(svs.core.detect.breakpoint.greaterThan('am'));
  const charityPayoutChart = useAtomValue(charityPayoutChartAtom);
  useCharityPayout();
  useEffect(() => {
    const listener = () => {
      if (svs.core.detect.breakpoint.lessThan('am')) {
        setIsHorizontal(false);
      } else {
        setIsHorizontal(true);
      }
    };
    svs.core.detect.breakpoint.on('change', listener);
    return () => svs.core.detect.breakpoint.off('change', listener);
  }, []);
  if (!charityPayoutChart) {
    return React.createElement("div", {
      className: "lp-charity-payout"
    }, React.createElement("div", {
      className: "charity-body"
    }, React.createElement("div", {
      className: "lp-header f-content"
    }, React.createElement("h3", null, "Tyv\xE4rr kunde vi inte hitta ", React.createElement("br", null), "f\xF6rdelningen av bidrag till v\xE5ra ", React.createElement("br", null), "samarbetsorganisationer f\xF6r ", React.createElement("br", null), "denna dragning."))));
  }
  return React.createElement("div", {
    className: "lp-charity-payout"
  }, React.createElement("div", {
    className: "charity-body"
  }, React.createElement("div", {
    className: "lp-header f-content"
  }, React.createElement("h3", null, "M\xE5nga vinner n\xE4r du spelar. ", React.createElement("br", null), " S\xE5 h\xE4r f\xF6rdelades v\xE5rt st\xF6d", React.createElement("br", null), " till v\xE4lg\xF6renhet i denna ", React.createElement("br", null), "dragning.")), React.createElement("div", {
    className: "chart-wrapper"
  }, React.createElement(CharityPayoutChart, {
    payoutChartData: charityPayoutChart,
    className: "text-white",
    horizontal: isHorizontal
  }))));
};
setGlobal('svs.lyckoplatsen.components.shared_charity_payout.react.components', {
  CharityPayout
});

 })(window);